import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/apiClient";
import { ShieldAlert, Zap, ChevronRight } from "lucide-react";

export const OwnerBalanceStrip = ({ isOwner }) => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!isOwner) return;
    api.get("/owner/credits").then((r) => setData(r.data)).catch(() => {});
  }, [isOwner]);

  if (!isOwner || !data || data.balance_credits == null) return null;

  const low = data.low;
  return (
    <button
      onClick={() => navigate("/dashboard/settings")}
      data-testid="owner-balance-strip"
      className={`w-full flex items-center justify-between gap-4 rounded-sm px-5 py-3.5 border text-left transition-[border-color] duration-200 ${low ? "border-red-500/50 bg-red-500/10" : "border-primary/30 bg-primary/5 hover:border-primary/50"}`}
    >
      <div className="flex items-center gap-3">
        <div className={`h-9 w-9 rounded-sm flex items-center justify-center ${low ? "bg-red-500/20" : "bg-primary/15"}`}>
          {low ? <ShieldAlert className="h-5 w-5 text-red-400" /> : <Zap className="h-5 w-5 text-primary" />}
        </div>
        <div>
          <p className="text-xs uppercase tracking-wider text-muted-foreground">Owner · Emergent balance {low && <span className="text-red-400 font-semibold">· LOW</span>}</p>
          <p className="font-display text-2xl tracking-tight leading-tight" data-testid="owner-strip-remaining">
            {data.remaining} <span className="text-sm text-muted-foreground">credits left</span>
          </p>
        </div>
      </div>
      <div className="flex items-center gap-1 text-sm text-muted-foreground shrink-0">
        {low ? "Top up & update" : "Manage"} <ChevronRight className="h-4 w-4" />
      </div>
    </button>
  );
};
